import type { DatePickerProps } from "antd";
import { DatePicker as AntdDatePicker } from "antd";
import type { ComponentProps, FC } from "react";

type RangePickerProps = ComponentProps<typeof AntdDatePicker.RangePicker>;

const RangePicker = (props: RangePickerProps) => (
  <AntdDatePicker.RangePicker getPopupContainer={(triggerEl) => triggerEl} {...props} />
);

const DatePicker: FC<DatePickerProps> & { RangePicker: typeof RangePicker } = (props) => (
  <AntdDatePicker getPopupContainer={(triggerEl) => triggerEl} {...props} />
);

DatePicker.RangePicker = RangePicker;

export default DatePicker;
